import { ASPECT_RATIOS } from "./constants";
export var getAspectRatioFromCountryCode = function getAspectRatioFromCountryCode(countryCode) {
  return ASPECT_RATIOS[countryCode] || ASPECT_RATIOS["us"];
};